/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface IDataSourceConfigurationScope extends angular.IScope {
        model: models.DataSourceConfigurationModel;
    }

    export class DataSourceConfigurationController implements IController {
        scope: IDataSourceConfigurationScope;

        constructor($scope: IDataSourceConfigurationScope,
            dataSourceService: services.DataSourceService,
            $routeParams: angular.route.IRouteParamsService,
            codeService: services.ManageSystemCodesService,
            $http: angular.IHttpService,
            growl: angular.growl.IGrowlService,
            $location: angular.ILocationService)
        {
            this.scope = $scope;
            var id = null;
            if ($routeParams["id"]) {
                id = $routeParams["id"];
            }
            this.scope.model = new models.DataSourceConfigurationModel(dataSourceService, id, $scope, codeService, $http, growl, $location);
        }
    }
}

warsApp.registerController('DataSourceConfigurationController', ['$scope', 'dataSourceService', '$routeParams','manageSystemCodesService','$http','growl','$location']);